export const thunkResponseCheckerSdk = async (
  fn: () => Promise<any>,
  rejectWithValue: (value: unknown) => any,
  isData = true,
  paginated = false
) => {
  const response = await fn();

  if (response.success) {
    if (isData && response.data !== undefined) {
      if (paginated) {
        const { hasNextPage, totalCount, currentPage } = response;

        return {
          data: response.data,
          meta: {
            hasNextPage,
            totalCount,
            currentPage,
          },
        };
      } else {
        return response.data;
      }
    } else if (
      isData &&
      (response.data === undefined || response.data === null)
    ) {
      throw new Error("No Data");
    } else {
      return;
    }
  }

  return rejectWithValue(response.errors);
};
